import { createUser } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { useNavigate } from "react-router-dom";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { reports_to, ...rest } = values;

  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) =>
          v !== "" && v !== undefined && v !== null && _ !== reports_to,
      ),
    ),

    reports_to: reports_to?.id,
  };
}

export function useCreateUser() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);

      try {
        const response = await createUser({ item: payload });
        return response;
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      toast.success("User Created Successfully");
      invalidateAllQueries();
      navigate("/organization/employees")
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
